// extracted by mini-css-extract-plugin
module.exports = {"drive-thumbnail":"styles_drive-thumbnail__3dkWq","drive-thumbnail-iframe":"styles_drive-thumbnail-iframe__2B01y"};